class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    // 防崩保护：如果找不到 details 节点，直接退出，不阻塞后续页面 JS 执行
    if (!this.mainDetailsToggle) return;

    this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;

    this.onFocusOutHandler = this.onFocusOut.bind(this);
    this.onToggleHandler = this.onToggle.bind(this);
    this.onDocumentClickHandler = this.onDocumentClick.bind(this);

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOutHandler);
    this.mainDetailsToggle.addEventListener('toggle', this.onToggleHandler);
    document.addEventListener('pointerdown', this.onDocumentClickHandler);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  onToggle() {
    if (!this.mainDetailsToggle) return;
    if (!this.animations) this.animations = this.content?.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations?.forEach((animation) => animation.play());
    } else {
      this.animations?.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
    }
  }

  disconnectedCallback() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeEventListener('focusout', this.onFocusOutHandler);
    this.mainDetailsToggle.removeEventListener('toggle', this.onToggleHandler);
    document.removeEventListener('pointerdown', this.onDocumentClickHandler);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);